import type { AnswerType } from '../../lib/quizData';
import styles from './AnswerButton.module.css';

interface Props {
  answer: AnswerType;
  onClick: () => void;
}

const CONFIG: Record<AnswerType, { label: string; className: string }> = {
  Yes: { label: 'Yes ♥', className: styles.yes },
  Maybe: { label: 'Maybe 😏', className: styles.maybe },
  No: { label: 'Not this time', className: styles.no },
};

export function AnswerButton({ answer, onClick }: Props) {
  const { label, className } = CONFIG[answer];
  return (
    <button className={`${styles.btn} ${className}`} onClick={onClick}>
      {label}
    </button>
  );
}
